import { FAServicesParams, FeatureAppMode } from '../types/service-configs';
import { FeatureAppNames } from './app-constants';
import { isTruthy } from './is-truthy';

export interface ModelOverviewIntegratorQueryParams {
  readonly carlineId?: string;
  readonly countryCode?: string;
  readonly currency?: string;
  readonly language?: string;
  readonly mode?: string;
  readonly faServicesUrl: string;
  readonly salesgroupId?: string;
  readonly showroomNodeId?: string;
  readonly trimName?: string;
  readonly ssr?: string;
  readonly galleryPath?: any;
  readonly galleryImages?: any;
  readonly graphQLServerUrl?: string;
  readonly featureAppName: string;
  readonly faServicesParams?: FAServicesParams;
}

export interface ModelOverviewIntegratorOptions {
  readonly carlineId?: string;
  readonly countryCode: string;
  readonly currency: string;
  readonly language: string;
  readonly mode: FeatureAppMode;
  readonly faServicesUrl: string;
  readonly salesgroupId?: string;
  readonly showroomNodeId?: string;
  readonly trimName?: string;
  readonly ssr?: boolean;
  readonly baseUrl?: string;
  readonly galleryPath?: any;
  readonly galleryImages?: any;
  readonly graphQLServerUrl?: string;
  readonly featureAppName?: string;
  readonly faServicesParams?: FAServicesParams;
}

const getMode = (modeQueryParam: string | undefined): FeatureAppMode => {
  if (!modeQueryParam) {
    return 'standalone';
  }
  return modeQueryParam as FeatureAppMode;
};

export const getFeatureAppName = (
  featureAppName: string | undefined,
): string => {
  const featureAppNames: string[] = Object.values(FeatureAppNames);
  if (!featureAppName || !featureAppNames.includes(featureAppName)) {
    return FeatureAppNames.DEFAULT;
  }
  return featureAppName;
};

export function createOptionsFromQueryParams(
  queryParams: ModelOverviewIntegratorQueryParams,
): ModelOverviewIntegratorOptions & any {
  const credentials = {
    username:
      typeof process !== 'undefined' ? (process.env.CMS_USERNAME ?? '') : '',
    password:
      typeof process !== 'undefined' ? (process.env.CMS_PASSWORD ?? '') : '',
  };

  const {
    countryCode = 'US',
    currency = 'USD',
    language = 'en',
    faServicesUrl = 'https://qa.vwservicesfa.svc.vwusa.io',
    mode: modeQueryParam,
    featureAppName,
    ssr,
    faServicesParams = {
      urlOrigin: 'https://cs-int-vw-us.lighthouselabs.eu',
      urlPath: '/en.service-config.json',
      credentials,
    },
  } = queryParams;

  return {
    countryCode,
    currency,
    language,
    faServicesUrl,
    mode: getMode(modeQueryParam),
    ssr: isTruthy(ssr),
    baseUrl: isTruthy(ssr) ? process.env.BASE_URL : '',
    featureAppName: getFeatureAppName(featureAppName),
    faServicesParams,
  };
}
